module.exports = __webpack_public_path__ + "img/header-v2.62df3a3e.png";